<template>
  <Modal maskClosable :title="title" v-model:visible="inviteVisible" :width="532" :footer="null">
    <div class="invite-warning">
      通过邀请链接加入团队的成员，将自动成为普通成员，其席位类型为查看席位，不可编辑或管理。
    </div>

    <div class="input-content">
      <div class="content-item">
        <a-input readonly :value="inviteUrl" />
      </div>
      <a-button type="primary" class="content-button" :loading="linkLoading" @click="handleCopy">
        复制链接
      </a-button>
    </div>

    <div class="invite-text">将链接发送给目标用户,点击即可加入团队</div>

    <div class="form-row">
      <div class="form-label">链接有效期</div>
      <a-select v-model:value="selectedHours" class="expiry-select" @change="handleExpireChange">
        <a-select-option v-for="option in expireOptions" :key="option.value" :value="option.value">
          {{ option.label }}
        </a-select-option>
      </a-select>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@elecmap/elecmap-ui'
import { message } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { updateInvitedTokenExpiryTime } from '@elecmap/api/src/ram'

const props = withDefaults(
  defineProps<{
    visible?: boolean
    inviteToken?: string
    title?: string
  }>(),
  {
    visible: false,
    title: '邀请员工加入',
  },
)

const emit = defineEmits<{
  (event: 'close'): void
}>()

const copy = (str: string) => {
  const input = document.createElement('textarea')
  document.body.appendChild(input)
  input.value = str
  input.select()
  document.execCommand('Copy')
  document.body.removeChild(input)
}

const inviteVisible = ref(false)
const token = ref('')
const inviteUrl = ref('')
const linkLoading = ref(false)
const selectedHours = ref(24)
const expireOptions = [
  { label: '1小时', value: 1 },
  { label: '1天', value: 24 },
  { label: '7天', value: 168 },
  { label: '14天', value: 336 },
  { label: '30天', value: 720 },
]

watch(
  () => props.visible,
  visible => {
    inviteVisible.value = !!visible
    if (!visible) {
      emit('close')
    }
  },
)

watch(inviteVisible, visible => {
  if (!visible) {
    emit('close')
  }
})

watch(
  () => props.inviteToken,
  newToken => {
    token.value = newToken || ''
    if (!token.value) {
      inviteUrl.value = ''
      return
    }
    inviteUrl.value = `${window.location.origin}/#/invite?invitedToken=${token.value}`
  },
  { immediate: true },
)

const handleExpireChange = async (hours: number) => {
  try {
    if (!token.value) {
      message.error('邀请链接不存在，请重新打开弹窗')
      return
    }
    linkLoading.value = true
    await updateInvitedTokenExpiryTime({
      token: token.value,
      hour: hours,
    })
  } catch (error) {
    message.error('更新链接有效期失败，请重试')
  } finally {
    linkLoading.value = false
  }
}

const handleCopy = () => {
  if (!inviteUrl.value) return
  copy(inviteUrl.value)
  message.success('链接已复制到剪贴板')
}
</script>

<style scoped lang="scss">
.form-row {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.form-label {
  width: 84px;
  color: #333;
}

.expiry-select {
  width: 160px;
}

.input-content {
  display: flex;
  justify-content: center;
  align-items: center;

  .content-item {
    width: 100%;
  }

  .content-button {
    margin-left: 20px;
  }
}

.invite-text {
  margin: 12px 0;
  color: #aaa;
}

.invite-warning {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  color: #ad6800;
  line-height: 20px;
}
</style>
